import React from 'react';
import { Grid, Typography, Tooltip } from '@material-ui/core';
import ReactToPrint from 'react-to-print';
import { AiOutlineDownload } from 'react-icons/ai';
import ExcelDownloadButton from './ExcelDownloadButton';

const timeout = delay => new Promise(res => setTimeout(res, delay));

export default function FinishStep({
  isMobile,
  seasonName,
  printRef,
  setPrint,
  downloadExcelURL,
  loadingOrder,
  onGenerateExcel,
  onClose,
}) {
  return (
    <Grid container justifyContent="center">
      <Typography
        display="inline"
        align="center"
        style={{
          fontFamily: 'Montserrat',
          fontSize: isMobile ? 18 : 24,
          marginTop: '5%',
        }}
      >
        Your order has been submitted and is now{' '}
        <span style={{ fontWeight: 'bold' }}>pending</span> approval.{' '}
      </Typography>
      <Grid container justifyContent="center">
        <Typography
          align="center"
          style={{ margin: isMobile ? '20% 0' : '7% 0px' }}
        >
          Thank you for submitting your order with FARM Rio
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Typography align="center">
          Sales will reach out if there any questions and if your order is
          confirmed
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Typography align="center" style={{ margin: '15px 0px' }}>
          In the meantime, If you have any questions please fell free to reach
          out to
        </Typography>
      </Grid>
      <Grid container justifyContent="center">
        <Typography align="center" display="inline">
          Gabriele -{' '}
          <span style={{ fontWeight: 'bold' }}>
            gabriele.petrauskaite@farmrio.com
          </span>
        </Typography>
      </Grid>
      <Grid
        container
        justifyContent="center"
        style={{ margin: isMobile ? '20% 0 15%' : '4% 0 4%' }}
      >
        <Grid
          style={{
            display: isMobile && 'flex',
            justify: 'center',
            margin: isMobile && '10px 0px',
            width: isMobile && 400,
          }}
        >
          <Grid
            container
            justifyContent="center"
            style={{ marginRight: !isMobile && 20 }}
          >
            <Typography variant="body2">Download Collection</Typography>
            <Tooltip title="Use 'Save as PDF' mode" style={{ marginLeft: 10 }}>
              <Grid>
                <ReactToPrint
                  trigger={() => (
                    <Grid
                      container
                      style={{
                        alignItems: 'center',
                        cursor: 'pointer',
                        height: 19,
                      }}
                    >
                      <AiOutlineDownload
                        size={16}
                        color="black"
                        style={{ marginTop: 2 }}
                      />{' '}
                      <span style={{ fontSize: 12 }}>PDF</span>
                    </Grid>
                  )}
                  content={() => printRef.current}
                  onAfterPrint={() => setPrint(false)}
                  onBeforeGetContent={async () => {
                    setPrint(true);
                    await timeout(1000);
                  }}
                />
              </Grid>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid
          style={{
            display: isMobile && 'flex',
            justify: 'center',
            margin: isMobile && '10px 0px',
          }}
        >
          <ExcelDownloadButton
            downloadExcelURL={downloadExcelURL}
            loading={loadingOrder}
            onGenerate={onGenerateExcel}
            seasonName={seasonName}
            style={{ marginLeft: !isMobile && 20 }}
          />
        </Grid>
      </Grid>
      <Grid
        style={{
          cursor: 'pointer',
          backgroundColor: 'black',
          padding: '8px 65px',
        }}
        onClick={onClose}
      >
        <Typography style={{ color: '#FFFFFF' }}>
          Go back to your collection
        </Typography>
      </Grid>
    </Grid>
  );
}
